import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import {Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
const API_URL = process.env.REACT_APP_API_URL_EC2;

const Register = () => {
  const [fname, setfname] = useState();
  const [lname, setlname] = useState();
  const [number, setnumber] = useState();
  const [password, setpassword] = useState();
  const [email, setemail] = useState();
  const [county, setcounty] = useState();
  const [categorypreference1, setcategorypreference1] = useState();
  const [categorypreference2, setcategorypreference2] = useState();
  const [address, setaddress] = useState();
  const [storedUser, setStoredUser] = useState(null);
  const [disabledstate, setdisabledstate] = useState(true);
  const [mrn, setmrn] = useState();
  const [error, setError] = useState('');
  const buttonStyle = {
    width: "100px", // Set the desired width
    height: "40px", // Set the desired height
    margin: "0 10px", // Margin to space out the buttons
  };

  useEffect(() => {
    const storedUserdata = sessionStorage.getItem("user");
    if (storedUserdata) {
      const data = JSON.parse(storedUserdata);
      setStoredUser(data);
      // Set mrn if it exists
      if (data.id) {
        setmrn(data.id);
      } else {
        console.error("ID is not available in stored user data.");
      }
    }
  }, []); // Empty dependency array to run only on mount

  const getUserData = useCallback(async () => {
    try {
      let response = await axios.post(`${API_URL}/api/usersbyid`, {
        id: mrn,
      });
      console.log("Response data:", response.data.data);

      if (response.data && response.data.data) {
        setfname(response.data.data.fname);
        setlname(response.data.data.lname);
        setnumber(response.data.data.number);
        setpassword(response.data.data.password);
        setemail(response.data.data.email);
        setcounty(response.data.data.county);
        setcategorypreference1(response.data.data.categorypreference1);
        setcategorypreference2(response.data.data.categorypreference2);
        setaddress(response.data.data.address);
      } else {
        console.error("User data is not available in the response.");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }, [mrn]);

  useEffect(() => {
    // Call getUserData when mrn is set
    if (mrn) {
      getUserData();
    }
  }, [mrn, getUserData]); // Depend on mrn so it runs whenever mrn changes




  const onEdit = async (e) => {
    setdisabledstate(false);
  };




  const onsubmit = async (e) => {
    //const isValid = formValidation();
    // console.log(fname)
    // console.log(lname)
    // console.log(number)
    // console.log(email)
    // console.log(county)
    // console.log(pincode)
    // console.log(pps)
    // console.log(address)
    // console.log(toggleState)
    // console.log(insnumber)

    if (true) {
      let response = await axios.post(`${API_URL}/api/updateUserData`, {
        id:mrn,
        fname: fname,
        lname: lname,
        number: number,
        password: password,
        email: email,
        county: county,
        address: address,
        categorypreference1:categorypreference1,
        categorypreference2:categorypreference2
      });

      console.log(response);

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Data Updated SuccessFully!",
          text: response.data.message,
          confirmButtonText: "OK",
        }).then(() => {
          getUserData();
          setdisabledstate(true);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Data Updation Failed",
          text: response.data.message,
          confirmButtonText: "OK",
        });
      }
    }
  };

  // const formValidation = () => {
  // 	const ownerNameerr = {};
  // 	const Shoperr = {};
  // 	const numbererr = {};
  // 	const emailerr = {};
  // 	const aadhaar = {};
  // 	const panerr = {};
  // 	let phoneno = /^\d{10}$/;
  // 	let Aadhar = /^[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}$/;
  // 	let Pan = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  // 	let Pincode = /^[1-9]{1}[0-9]{2}[0-9]{3}$/;
  // 	let isValid = true;

  // 	if (owner.trim().length < 2) {
  // 		ownerNameerr.ownerNameshort = "First Name Short";
  // 		isValid = false;
  // 	}
  // 	setownerNameerr(ownerNameerr);

  // 	if (shop.trim().length < 2) {
  // 		Shoperr.Shoperrshort = "Shop Name Short";
  // 		isValid = false;
  // 	}
  // 	setShoperr(Shoperr);

  // 	if (!number.match(phoneno)) {
  // 		numbererr.numbererrshort = "Enter Valid No";
  // 		isValid = false;
  // 	}
  // 	setnumbererr(numbererr);

  // 	if (!email.includes("@")) {
  // 		emailerr.emailerrshort = "Enter Valid Email";
  // 		isValid = false;
  // 	}
  // 	setemailerr(emailerr);

  // 	if (!aadhar.match(Aadhar)) {
  // 		aadhaar.aadhaarerr = "Enter Valid Aadhar";
  // 		isValid = false;
  // 	}
  // 	setAadharerr(aadhaar);

  // 	if (!pan.match(Pan)) {
  // 		panerr.paanerr = "Enter Valid Pan";
  // 		isValid = false;
  // 	}
  // 	setPanerr(panerr);

  // 	if (!pincode.match(Pincode)) {
  // 		pinerr.piinerr = "Enter Valid Pincode";
  // 		isValid = false;
  // 	}
  // 	setPinerr(pinerr);

  // 	return isValid;
  // };

  // useEffect(() => {
  // 	returnAllShops();
  // 	getUserGateways();
  // }, []);

  return (
    <div>
      <section id="contact" className="contact">
        <div className="container">
          <Row>
            <Col md={2}>
            </Col>

            <Col md={9}>
              <div
                className="row"
                style={{
                  backgroundColor: "white",
                  marginTop: "20px",
                  marginBottom: "20px",
                  padding: "20px",
                  border: "2px solid rgba(0, 0, 0, 0.7)", // Solid black border with 0.7 opacity
                  borderRadius: "10px", // Rounded corners
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Subtle shadow for depth
                  maxWidth: "900px", // Optional: Limit the width for better layout
                }}
              >
                <div
                  className="col-lg-12 aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div
                    className="col-lg-12 aos-init aos-animate"
                    data-aos="fade-right"
                  >
                    <div className="row">
                      <div className="col-md-8">
                        <h4
                          style={{
                            fontWeight: "bold", // Make the text bold
                            textAlign: "center", // Center the heading
                            marginBottom: "20px", // Add spacing below
                            borderBottom: "2px solid #1976d2", // Bottom border for separation
                            paddingBottom: "10px", // Padding below the text
                            display: "inline-block", // Shrinks to fit the content
                          }}
                        >
                          User Details
                        </h4>
                      </div>

                      <div className="col-md-4">
                        <h6
                          style={{
                            fontSize: "1.25rem",
                            color: "#007bff",
                            fontWeight: "bold",
                            fontFamily: "Arial, sans-serif",
                          }}
                        >
                          User ID :{" "}
                          {storedUser ? storedUser.id || "MRN" : "Loading..."}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="border-wrapper">
                    <div className="php-email-form mt-4">
                      <div className="row">
                        <div className="col-md-6 form-group">
                          <Form.Label style={{ fontWeight: "bold" }}>
                            First Name
                          </Form.Label>
                          <input
                            disabled={true}
                            type="text"
                            name="fname"
                            className="form-control"
                            id="fname"
                            placeholder="Your Name"
                            value={fname}
                            onChange={(e) => {
                              setfname(e.target.value);
                            }}
                            required=""
                          />
                        </div>

                        <div className="col-md-6 form-group mt-3 mt-md-0">
                          <Form.Label style={{ fontWeight: "bold" }}>
                            Last Name
                          </Form.Label>
                          <input
                            disabled={true}
                            type="text"
                            className="form-control"
                            name="lname"
                            id="lname"
                            placeholder="Your Last Name"
                            value={lname}
                            onChange={(e) => {
                              setlname(e.target.value);
                            }}
                            required=""
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 form-group mt-3 mt-md-0">
                          <Form.Label style={{ fontWeight: "bold" }}>
                            Mobile Number
                          </Form.Label>
                          <input
                            disabled={true}
                            type="number"
                            className="form-control"
                            name="number"
                            placeholder="Your number"
                            value={number}
                            onChange={(e) => {
                              setnumber(e.target.value);
                            }}
                            required=""
                          />
                        </div>

                        <div className="col-md-6 form-group mt-3 mt-md-0">
                          <Form.Label style={{ fontWeight: "bold" }}>
                            Email
                          </Form.Label>
                          <input
                            disabled={true}
                            type="email"
                            className="form-control"
                            name="email"
                            id="email"
                            placeholder="Your email"
                            value={email}
                            onChange={(e) => {
                              setemail(e.target.value);
                            }}
                            required=""
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 form-group mt-3 mt-md-0">
                          <Form.Label style={{ fontWeight: "bold" }}>
                            County
                          </Form.Label>
                          <input
                            disabled={disabledstate}
                            type="text"
                            className="form-control"
                            name="county"
                            id="county"
                            placeholder="Your County"
                            value={county}
                            onChange={(e) => {
                              setcounty(e.target.value);
                            }}
                            required=""
                          />
                        </div>

                        <div className="col-md-6 form-group mt-3 mt-md-0">
                          <Form.Label style={{ fontWeight: "bold" }}>
                            Category Preference 1
                          </Form.Label>
                          <select
                            disabled={disabledstate}
                            className="form-control"
                            name="categorypreference1"
                            value={categorypreference1}
                            onChange={(e) =>
                              setcategorypreference1(e.target.value)
                            }
                            required
                          >
                            <option value="">Select Preference</option>
                            <option key="gaming" value="gaming">
                              Gaming
                            </option>
                            <option key="clothing" value="clothing">
                              Clothing
                            </option>
                            <option key="watches" value="watches">
                              Watches
                            </option>
                            <option key="books" value="books">
                              Books
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 form-group mt-3 mt-md-0">
                          <Form.Label style={{ fontWeight: "bold" }}>
                            Category Preference 2
                          </Form.Label>
                          <select
                            disabled={disabledstate}
                            className="form-control"
                            name="categorypreference2"
                            value={categorypreference2}
                            onChange={(e) =>
                              setcategorypreference2(e.target.value)
                            }
                            required
                          >
                            <option value="">Select Preference</option>
                            <option key="gaming" value="gaming">
                              Gaming
                            </option>
                            <option key="clothing" value="clothing">
                              Clothing
                            </option>
                            <option key="watches" value="watches">
                              Watches
                            </option>
                            <option key="books" value="books">
                              Books
                            </option>
                          </select>
                        </div>

                      </div>

                      <div className=" form-group mt-3 mt-md-0">
                        <Form.Label style={{ fontWeight: "bold" }}>
                          Address
                        </Form.Label>
                        <input
                          disabled={disabledstate}
                          type="text"
                          className="form-control"
                          name="address"
                          id="address"
                          placeholder="Address"
                          value={address}
                          onChange={(e) => {
                            setaddress(e.target.value);
                          }}
                          required=""
                        />
                      </div>

                      <div
                        className="text-center"
                        style={{ paddingTop: "10px" }}
                      >
                        <Button
                          style={buttonStyle}
                          onClick={() => {
                            onEdit();
                          }}
                        >
                          Edit
                        </Button>
                        &nbsp; &nbsp; &nbsp;
                        <Button
                          style={buttonStyle}
                          onClick={() => {
                            onsubmit();
                          }}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default Register;
